import React, {useContext} from 'react';
import {Row, Col, ProgressBar} from 'react-bootstrap';
import styles from './section-basic-details.module.scss';
import {remainingDays, strToDate, toCurrency} from "../../../../../helpr/helper";
import {SecurityContext} from "../../../../../context/security-context";
import clock from "../../../../../assets/clock.svg"

/*
  Basic Details Section of the Security containing logo
  issue name, allocation, and offer size
 */
const BasicDetailsSection = () => {
  //Get security information from context
  const { securityState, ordersState } = useContext(SecurityContext);
  const totalOrders = () => {
    return ordersState.default.reduce((total, o) => total + o.scaledAmount, 0)
  }
  const totalAccepted = () => {
    return ordersState.default.filter(o => o.orderStatus === '1')
      .reduce((total, o) => total + o.scaledAmount, 0)
  }
  const percentage = () => {
    if(!securityState.offerSize){
      return 0;
    }
    return Math.round((totalAccepted() / securityState.allocation) * 100);
  }
  const start = strToDate(securityState.offerDate);
  const end = strToDate(securityState.offerCloseDate);
  const now = new Date();
  const getStatus = (status) => {
    switch(status){
      case '0':
        if(totalAccepted() === securityState.allocation){
          return 'Complete'
        }
        return 'Ongoing'
      case '1':
        return 'Submitted'
      case '2':
        return 'Authorized'
      default:
        return ''
    }
  }

  return (
    <div className={`${styles['basic-details']} ${styles['section']}`}>
      <Row>
        {/*<Col lg={12}>*/}
        {/*  <div className={styles['security-logo']}>*/}
        {/*    <img alt={securityState.securityName} src={securityState.iconUrlSrc} />*/}
        {/*  </div>*/}
        {/*</Col>*/}
        <Col lg={12}>
          <div className={`${styles['security-heading']} ${styles['wrap']}`}>
            <h1>{securityState.securityName}</h1>
          </div>
        </Col>
        <Col xs={7} lg={7}>
          <div className={styles['duration-period']}>
            <label>{securityState.offerDate} to {securityState.offerCloseDate}</label>
          </div>
        </Col>
        {now < start ? ''
          : (
            <Col xs={5} lg={5}>
              <div className={styles['duration-remaining']}>
                <img alt="Clock" src={clock} />{' '}{remainingDays(new Date(), end) > 0 ? `${remainingDays(new Date(), end)} days` : 'Closed'}
              </div>
            </Col>
          )
        }
      </Row>
      {now < start ? ''
        : (
          <Row>
            <Col xs={6} lg={6}>
              <div className={styles['security-detail-label']}>
                <label>Status</label>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['security-detail-value']}>
                <span>{getStatus(securityState.securityStatus)}</span>
              </div>
            </Col>
          </Row>
        )
      }
      <Row>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-label']}>
            <label>Original Offer Amount</label>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-value']}>
            <span>{securityState.currency}{' '}{ securityState.offerSize ? toCurrency(securityState.offerSize) : 0.00}</span>
          </div>
        </Col>
      </Row>
      { securityState.offerSize === securityState.revisedOfferSize ? ''
        : <Row>
          <Col xs={6} lg={6}>
            <div className={styles['security-detail-label']}>
              <label>
                Revised Offer Amount<br/>
                <span className={styles['revised-date']}>{`As of ${securityState.revisedOfferSizeDate}`}</span>
              </label>
            </div>
          </Col>
          <Col xs={6} lg={6}>
            <div className={styles['security-detail-value']}>
              <span>{securityState.currency}{' '}{ securityState.revisedOfferSize ? toCurrency(securityState.revisedOfferSize) : 0.00}</span>
            </div>
          </Col>
        </Row>
      }
      <Row>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-label']}>
            <label>
              Allocation<br/>
              <span className={styles['revised-date']}>{`As of ${securityState.revisedAllocationDate}`}</span>
            </label>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-value']}>
            <span>{securityState.currency}{' '}{ securityState.offerSize ? toCurrency(securityState.allocation) : 0.00}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-label']}>
            <label>Total Reservations Taken</label>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-value']}>
            <span>{securityState.currency}{' '}{ toCurrency(totalOrders()) }</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-label']}>
            <label>Total Reservations Accepted</label>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['security-detail-value']}>
            <span className={styles['current']}>{securityState.currency}{' '}{toCurrency(totalAccepted())}</span>
          </div>
        </Col>
        <Col lg={12}>
          <div className={styles['security-allocation']}>
            <ProgressBar className={styles['progress']} now={percentage()} label={`${percentage() > 30 ? `${percentage()}%` : ''}`} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default BasicDetailsSection;
